import { MultipleChoiceExamStatics } from '../../../../store/workspace/types';
import { ListItem } from '../../../../store/general/types';
import { useMemo, useState } from 'react';
import { QUESTION_LEVEL_FILTERS, QUESTION_TYPE_FILTERS } from '../constants';
import { IndexedQuestion } from '../types';

/**
 * Level/type filtering of a multiple choice exam. Questions keep their original
 * index because the applicant's answers are addressed positionally.
 */
export function useFilteredQuestions(examData: MultipleChoiceExamStatics | null) {
    const [questionType, setQuestionType] = useState<ListItem>(QUESTION_TYPE_FILTERS[0]);
    const [questionLevel, setQuestionLevel] = useState<ListItem>(QUESTION_LEVEL_FILTERS[0]);

    const questions = useMemo<IndexedQuestion[]>(() => {
        if (!examData) return [];

        return examData.exam.questions
            .map((question, index) => ({ ...question, index }))
            .filter(question =>
                (questionType.id === 'all' || question.type === questionType.id) &&
                (questionLevel.id === 'all' || question.level === questionLevel.id));
    }, [examData, questionType, questionLevel]);

    return {
        questions,
        questionType,
        questionLevel,
        setQuestionType,
        setQuestionLevel,
    };
};
